import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import { DragDropContext } from 'react-beautiful-dnd';
import { Grid } from 'semantic-ui-react';

import { getControlInfo } from 'State/controlInfo/actions';
import {
  POS_ROUTES,
  ITEMS_PER_ROW,
} from 'PointOfSale/modules/common/constants';
import * as POSSelectors from 'PointOfSale/selectors';
import { getServerTime } from 'State/serverTime/actions';
import { getOffsetMinutes } from 'State/timeZones/actions';
import { moveItem } from 'PointOfSale/state/actions';
import PageHeader from 'PointOfSale/modules/layouts/container/PageHeader';
import PageContent from 'PointOfSale/modules/layouts/component/PageContent';
import PageFooter from 'PointOfSale/modules/layouts/component/PageFooter';
import PosSideBar from 'PointOfSale/modules/layouts/component/pageSidebar/SideBar';
import SetDateAndSite from 'PointOfSale/modules/setDateAndSite/container';

import 'PointOfSale/styles/posApp.less';

class POSHomeContainer extends React.Component {
  static path = POS_ROUTES.HOME;
  static exact = false;
  static routeKey = POS_ROUTES.HOME;

  static propTypes = {
    pathname: PropTypes.string,
  };

  componentDidMount() {
    const { history, selectedSiteDetails, match } = this.props;

    // only replace back to POS_ROUTES.HOME if within POS and not at POS_ROUTES.HOME
    if (match.path === POS_ROUTES.HOME && !match.isExact) {
      if (_.isEmpty(selectedSiteDetails)) {
        history.replace(this.getRootUrl());
      }
    }

    this.requestData();
  }

  requestData = () => {
    const { getServerTime, getControlInfo, getOffsetMinutes } = this.props;
    getServerTime();
    getControlInfo();
    getOffsetMinutes();
  };

  getRootUrl = () => this.props.match.url.replace(/\/pointofsale\/.*/gi, '');

  onDragEnd = event => {
    const { draggableId, source, destination } = event;

    if (!destination) {
      return;
    }

    const ItemId = draggableId.split('-')[1];

    const startRow = source.droppableId.split('-')[1];
    const startCol = source.index;
    const startIndex = startRow * ITEMS_PER_ROW + startCol;

    const destRow = destination.droppableId.split('-')[1];
    const destCol = destination.index;
    const destIndex = destRow * ITEMS_PER_ROW + destCol;

    this.props.moveItem(ItemId, startIndex, destIndex);
  };

  render() {
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <div id="pos-main-container">
          <Grid padded className="page-header stretched">
            <PageHeader />
          </Grid>
          <Grid
            padded
            stretched
            id="main-container-id"
            className="flex-1 flex-no-wrap min-h-0"
          >
            <Grid.Column width={3} className="side-bar">
              <PosSideBar />
            </Grid.Column>
            <Grid.Column width={13} className="pos-content-container">
              <PageContent />
            </Grid.Column>
          </Grid>
          <PageFooter />
          <SetDateAndSite />
        </div>
      </DragDropContext>
    );
  }
}

const mapStateToProps = state => ({
  selectedSiteDetails: POSSelectors.getSelectedSiteDetails(state),
});

const mapDispatchToProps = dispatch => ({
  getControlInfo: () => dispatch(getControlInfo()),
  getServerTime: () => dispatch(getServerTime()),
  getOffsetMinutes: () => dispatch(getOffsetMinutes()),
  moveItem: (ItemId, startIndex, destIndex) =>
    dispatch(moveItem(ItemId, startIndex, destIndex)),
});

export const PointOfSale = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(POSHomeContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/index.js